// React Imports
import type { SVGAttributes } from 'react';
import React from 'react';

export const InnoEcosystem = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none" {...props}>
      <path
        d="M36.2949 24.9625C35.2777 18.6887 25.6737 19.7571 26.5261 26.2412C27.7252 32.2933 36.6756 31.2989 36.3062 25.0705L36.2949 24.9625ZM34.2661 25.7865C33.7547 29.344 28.4469 29.0655 28.5435 25.3831C28.8334 21.7233 34.4196 22.0245 34.2718 25.6842L34.2604 25.7865H34.2661Z"
        fill="url(#paint0_linear_9267_215600)"
      />
      <path
        opacity="0.9"
        d="M30.4248 23.0527C30.4248 23.0527 30.4248 23.0635 30.4141 23.0581C30.4141 23.0581 30.4195 23.0581 30.4248 23.0527Z"
        fill="url(#paint1_linear_9267_215600)"
      />
      <path
        d="M22.0314 25.9055C22.5088 25.9055 22.918 25.5531 22.9691 25.0758C23.3726 21.0808 26.5947 17.9154 30.6409 17.5517C30.8966 17.529 31.1523 17.5177 31.4081 17.5177C35.7952 17.5177 39.4038 20.8194 39.847 25.0474C39.8982 25.5304 40.2903 25.9055 40.7733 25.9055H42.4611C43.018 25.9055 43.4499 25.4224 43.3988 24.8655C42.8589 18.7792 37.6989 14 31.4081 14C31.0273 14 30.6522 14.017 30.2772 14.0511C24.5205 14.5796 19.9345 19.1316 19.4174 24.8371C19.4174 24.8541 19.4174 24.8655 19.4174 24.8826C19.3719 25.4281 19.8038 25.8998 20.3493 25.8998H22.0314V25.9055Z"
        fill="url(#paint2_linear_9267_215600)"
      />
      <path
        d="M43.4009 27.4235C43.4009 27.4235 43.4009 27.4576 43.4009 27.4746C43.1054 30.7081 41.5085 33.5723 39.1331 35.5385C37.343 37.0217 36.3258 39.2437 36.3258 41.568C36.3258 42.6363 35.4563 43.5058 34.388 43.5058H28.4381C27.3697 43.5058 26.5002 42.6363 26.5002 41.568C26.5002 39.2437 25.4944 37.0217 23.7043 35.5442C21.3119 33.5666 19.7036 30.6797 19.4252 27.4178C19.3797 26.8779 19.8116 26.4062 20.3571 26.4062H22.0506C22.5337 26.4062 22.9314 26.7699 22.9826 27.253C23.4145 31.4924 27.0287 34.7941 31.4216 34.7941C31.683 34.7941 31.9387 34.7827 32.1944 34.76C36.2349 34.4019 39.4627 31.2309 39.8605 27.2416C39.906 26.7643 40.3208 26.4119 40.7982 26.4119H42.395C42.9576 26.4119 43.4123 26.8666 43.4123 27.4292L43.4009 27.4235Z"
        fill="url(#paint3_linear_9267_215600)"
      />
      <path
        d="M34.03 44.3281H28.7905C27.6355 44.3281 26.6992 45.2644 26.6992 46.4194C26.6992 47.5744 27.6355 48.5107 28.7905 48.5107H34.03C35.185 48.5107 36.1213 47.5744 36.1213 46.4194C36.1213 45.2644 35.185 44.3281 34.03 44.3281Z"
        fill="black"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9267_215600"
          x1="28.9641"
          y1="20.6152"
          x2="33.3739"
          y2="29.4917"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="0.52" stopColor="#93969B" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9267_215600"
          x1="30.4141"
          y1="23.0581"
          x2="30.4248"
          y2="23.0366"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.03" stopColor="#FFFFBB" />
          <stop offset="0.23" stopColor="#FEDE9E" />
          <stop offset="0.71" stopColor="#FDC767" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9267_215600"
          x1="26.4868"
          y1="15.3184"
          x2="39.0628"
          y2="37.4188"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3720F" />
          <stop offset="0.05" stopColor="#C4801B" />
          <stop offset="0.13" stopColor="#EEA339" />
          <stop offset="0.27" stopColor="#F6C16D" />
          <stop offset="0.39" stopColor="#FEDE9E" />
          <stop offset="0.53" stopColor="#FDC767" />
          <stop offset="1" stopColor="#DB9044" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_9267_215600"
          x1="24.5795"
          y1="16.3988"
          x2="37.1555"
          y2="38.4992"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3720F" />
          <stop offset="0.05" stopColor="#C4801B" />
          <stop offset="0.13" stopColor="#EEA339" />
          <stop offset="0.27" stopColor="#F6C16D" />
          <stop offset="0.39" stopColor="#FEDE9E" />
          <stop offset="0.53" stopColor="#FDC767" />
          <stop offset="1" stopColor="#DB9044" />
        </linearGradient>
      </defs>
    </svg>
  );
};
